import React, { useState, useEffect, useCallback } from 'react';
import type { CSSProperties } from 'react';
import { useDrop } from 'react-dnd';
import { ItemTypes } from './ItemTypes';
import { Card } from './Card';
import { integer } from 'aws-sdk/clients/cloudfront';
import update from 'immutability-helper';
import { Typography } from '@mui/material';

const style: CSSProperties = {
  minHeight: 250,
};

const style1: CSSProperties = {
  border: '1px dashed gray',
  float: 'left',
};

export interface DustbinProps {
  allowedDropEffect: string
}

function selectBackgroundColor(isActive: boolean, canDrop: boolean) {
  if (isActive) {
    return 'darkgreen'
  } else if (canDrop) {
    return 'darkkhaki'
  } else {
    return '#e0e0e0'
  }
}

export const Dustbin = (props: any) => {
  const [{ canDrop, isOver }, drop] = useDrop(
    () => ({
      accept: ItemTypes.BOX,
      drop: () => ({
        name: `${props?.allowedDropEffect} Dustbin`,
        allowedDropEffect: props?.allowedDropEffect,
      }),
      collect: (monitor: any) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    }),
    [props?.allowedDropEffect],
  );

  const moveCard = useCallback((dragIndex: number, hoverIndex: number) => {
    props.setItems((prevCards: any) =>
      update(prevCards, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, prevCards[dragIndex] as any],
        ],
      }),
    )
  }, [])

  const renderCard = useCallback(
    (card: { id: number; text: string }, index: number) => {
      return (
        <Card
          key={card.id}
          index={index}
          id={card.id}
          text={card.text}
          moveCard={moveCard}
          setInputId={props.setInputId}
          items={props.items}
          setItems={props.setItems}
        />
      )
    },
    [],
  )

  const isActive = canDrop && isOver;
  const backgroundColor = selectBackgroundColor(isActive, canDrop);

  return (
    <div ref={drop as any} style={{ ...style, backgroundColor }}>
      <Typography align="center" variant='h6' gutterBottom>{isActive ? 'Release to drop' : 'Drag here'}</Typography>
      <div>{props?.items.map((card: any, i: integer) => renderCard(card, i))}</div>
      {
        /* props?.items.map((e: any) => {
          return <div style={{ ...style1 }} key={e.id}>
            {e?.text}
          </div>
        }) */
      }
    </div>
  )
}
